import { inject, Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthUserConfig } from 'features/user/config/config.module';
import { MODAL_SIZE, ModalService } from 'shared/components/modal';
import { InactiveModalComponent } from 'features/user/components/inactive-modal/inactive-modal.component';
import { AuthStore, UserAuthEvent } from 'features/user/store/auth.store';
import { EventService } from 'shared/services/event.service';
import { Subscription } from 'rxjs';

@Injectable()
export class UserIdleService {
  lastPing?: Date;
  title = 'angular-idle-timeout';

  authStore = inject(AuthStore);
  eventService = inject(EventService);
  started: boolean = false;
  subscription = new Subscription();
  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private config: AuthUserConfig,
    private modalService: ModalService
  ) {
  }

  init() {
    if (this.authStore.isLoggedIn()) {
      this.start();
    }

    this.eventService.on(UserAuthEvent.LOGIN, () => {
      this.start();
    });
    this.eventService.on(UserAuthEvent.LOGOUT, () => {
      this.stop();
    });
  }

  start() {
    if (this.started) {
      return;
    }
    if (!this.authStore.isLoggedIn()) {
      return;
    }

    this.started = true;
    // sets an idle timeout
    const idleSeconds = this.config.user?.auth?.sessionIdleSeconds;
    if (!idleSeconds) {
      return;
    }

    this.idle.setIdle(idleSeconds);

    // sets a timeout period of 5 seconds after idle
    const inactiveModalTimoutSeconds = this.config.user?.auth?.inactiveModalTimoutSeconds ?? 5;
    this.idle.setTimeout(inactiveModalTimoutSeconds);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.subscription.add(this.idle.onIdleStart.subscribe(() => {
      this.modalService.openModal({
        data: {
          idle: this.idle
        },
        size: MODAL_SIZE.sm,
        body: InactiveModalComponent,
      });
    }));

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);
    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }

  stop() {
    this.idle.stop();
    this.started = false;
    this.subscription.unsubscribe();
  }
  reset() {
    this.idle.watch();
  }
}
